/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function DocsSiteUnpublished({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><circle cx={8} cy={8} r={4.07} stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2} /><path stroke="currentColor" strokeLinejoin="round" strokeWidth={1.2} d="m11 5-6 6" /><path fill="currentColor" fillRule="evenodd" d="M.4 4A2.6 2.6 0 0 1 3 1.4h10A2.6 2.6 0 0 1 15.6 4v8a2.6 2.6 0 0 1-2.6 2.6H3A2.6 2.6 0 0 1 .4 12V4ZM3 2.6A1.4 1.4 0 0 0 1.6 4v8A1.4 1.4 0 0 0 3 13.4h10a1.4 1.4 0 0 0 1.4-1.4V4A1.4 1.4 0 0 0 13 2.6H3Z" clipRule="evenodd" /></svg>;
}
;